// AllTopUps.jsx
import React, { useState } from 'react';
import styles from "./AllTopUps.module.css";
import RazorpayCheckout from '../RazorpayCheckout';

export default function AllTopUps() {
  // AI Messages Top-Up states
  const [showAiTopUpModal, setShowAiTopUpModal] = useState(false);
  const [aiTopUpAmount, setAiTopUpAmount] = useState(1500);
  const [aiTopUpMessages, setAiTopUpMessages] = useState(750);

  // Ingestion Storage Top-Up states
  const [showIngestionTopUpModal, setShowIngestionTopUpModal] = useState(false);
  const [ingestionTopUpAmount, setIngestionTopUpAmount] = useState(1500);
  const [ingestionTopUpSize, setIngestionTopUpSize] = useState(250000);  // Changed: 750 → 250000

  // Site Users Top-Up states
  const [showSiteUsersTopUpModal, setShowSiteUsersTopUpModal] = useState(false);
  const [siteUsersTopUpAmount, setSiteUsersTopUpAmount] = useState(1500);
  const [siteUsersTopUpQuantity, setSiteUsersTopUpQuantity] = useState(125);  // Changed: 25 → 125

  const handleAiTopUp = () => {
    setShowAiTopUpModal(true);
  };

  const handleIngestionTopUp = () => {
    setShowIngestionTopUpModal(true);
  };

  const handleSiteUsersTopUp = () => {
    setShowSiteUsersTopUpModal(true);
  };

  return (
    <>
      <div className={styles.allTopUpsContainer}>
        <h2 className={styles.sectionTitle}>💎 Top Up Your Resources</h2>
        <p className={styles.sectionSubtitle}>
          Purchase additional AI messages, storage space, and site users as you need them
        </p>

        <div className={styles.topUpCardsContainer}>
          {/* AI Messages Top-Up Card */}
          <div className={styles.topUpCard}>
            <div className={styles.cardIcon}>🔋</div>
            <h3 className={styles.cardTitle}>AI Messages</h3>
            <p className={styles.cardDescription}>
              Need more AI interactions? Top up your message credits instantly.
            </p>
            <div className={styles.pricingOptions}>
              <div className={styles.priceOption}>
                <span className={styles.price}>₹1500</span>
                <span className={styles.quantity}>+750 messages</span>
                <span className={styles.perUnit}>~₹2/message</span>
              </div>
              <div className={styles.priceOption}>
                <span className={styles.price}>₹3000</span>
                <span className={styles.quantity}>+1500 messages</span>
                <span className={styles.perUnit}>~₹2/message</span>
              </div>
              <div className={styles.priceOption}>
                <span className={styles.price}>₹4500</span>
                <span className={styles.quantity}>+2250 messages</span>
                <span className={styles.perUnit}>~₹2/message</span>
              </div>
            </div>
            <button onClick={handleAiTopUp} className={styles.topUpButton}>
              Top Up AI Messages →
            </button>
          </div>

          {/* Ingestion Storage Top-Up Card */}
          <div className={styles.topUpCard}>
            <div className={styles.cardIcon}>💾</div>
            <h3 className={styles.cardTitle}>Ingestion Storage</h3>
            <p className={styles.cardDescription}>
              Running out of space? Add more storage for your documents and data.
            </p>
            <div className={styles.pricingOptions}>
              <div className={styles.priceOption}>
                <span className={styles.price}>₹1500</span>
                <span className={styles.quantity}>+250000KB storage</span>  {/* Changed: 750KB → 250000KB */}
                <span className={styles.perUnit}>~₹0.006/KB</span>  {/* Changed: ₹2/KB → ~₹0.006/KB (1500/250000) */}
              </div>
              <div className={styles.priceOption}>
                <span className={styles.price}>₹3000</span>
                <span className={styles.quantity}>+500000KB storage</span>  {/* Changed: 1500KB → 500000KB */}
                <span className={styles.perUnit}>~₹0.006/KB</span>  {/* Changed: ₹2/KB → ~₹0.006/KB */}
              </div>
              <div className={styles.priceOption}>
                <span className={styles.price}>₹4500</span>
                <span className={styles.quantity}>+750000KB storage</span>  {/* Changed: 2250KB → 750000KB */}
                <span className={styles.perUnit}>~₹0.006/KB</span>  {/* Changed: ₹2/KB → ~₹0.006/KB */}
              </div>
            </div>
            <button onClick={handleIngestionTopUp} className={styles.topUpButton}>
              Top Up Storage →
            </button>
          </div>

          {/* Site Users Top-Up Card */}
          <div className={styles.topUpCard}>
            <div className={styles.cardIcon}>👥</div>
            <h3 className={styles.cardTitle}>Site Users</h3>
            <p className={styles.cardDescription}>
              Need to add more users to your AI agents? Top up your site user slots.
            </p>
            <div className={styles.pricingOptions}>
              <div className={styles.priceOption}>
                <span className={styles.price}>₹1500</span>
                <span className={styles.quantity}>+125 users</span>  {/* Changed: 25 users → 125 users */}
                <span className={styles.perUnit}>~₹12/user</span>  {/* Changed: ₹60/user → ~₹12/user */}
              </div>
              <div className={styles.priceOption}>
                <span className={styles.price}>₹3000</span>
                <span className={styles.quantity}>+250 users</span>  {/* Changed: 50 users → 250 users */}
                <span className={styles.perUnit}>~₹12/user</span>  {/* Changed: ₹60/user → ~₹12/user */}
              </div>
              <div className={styles.priceOption}>
                <span className={styles.price}>₹4500</span>
                <span className={styles.quantity}>+375 users</span>  {/* Changed: 75 users → 375 users */}
                <span className={styles.perUnit}>~₹12/user</span>  {/* Changed: ₹60/user → ~₹12/user */}
              </div>
            </div>
            <button onClick={handleSiteUsersTopUp} className={styles.topUpButton}>
              Top Up Site Users →
            </button>
          </div>
        </div>

        <div className={styles.infoNote}>
          <span className={styles.infoIcon}>ℹ️</span>
          <p>
            Top-ups are one-time purchases and never expire. They add to your existing
            limits and are consumed first before your monthly allocation.
          </p>
        </div>
      </div>

      {/* AI Messages Top-Up Modal */}
      {showAiTopUpModal && (
        <div className={styles.modalOverlay} onClick={() => setShowAiTopUpModal(false)}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h3>🔋 Top Up AI Messages</h3>
              <button
                className={styles.modalClose}
                onClick={() => setShowAiTopUpModal(false)}
              >
                ✕
              </button>
            </div>

            <div className={styles.modalBody}>
              <div className={styles.topUpOptions}>
                <div
                  className={`${styles.topUpOption} ${aiTopUpAmount === 1500 ? styles.selected : ''}`}
                  onClick={() => {
                    setAiTopUpAmount(1500);
                    setAiTopUpMessages(750);
                  }}
                >
                  <div className={styles.optionPrice}>₹1500</div>
                  <div className={styles.optionMessages}>+750 AI Messages</div>
                  <div className={styles.optionPerMessage}>~₹2 per message</div>
                  {aiTopUpAmount === 1500 && <div className={styles.selectedBadge}>✓ Selected</div>}
                </div>

                <div
                  className={`${styles.topUpOption} ${aiTopUpAmount === 3000 ? styles.selected : ''}`}
                  onClick={() => {
                    setAiTopUpAmount(3000);
                    setAiTopUpMessages(1500);
                  }}
                >
                  <div className={styles.optionPrice}>₹3000</div>
                  <div className={styles.optionMessages}>+1500 AI Messages</div>
                  <div className={styles.optionPerMessage}>~₹2 per message</div>
                  {aiTopUpAmount === 3000 && <div className={styles.selectedBadge}>✓ Selected</div>}
                </div>

                <div
                  className={`${styles.topUpOption} ${aiTopUpAmount === 4500 ? styles.selected : ''}`}
                  onClick={() => {
                    setAiTopUpAmount(4500);
                    setAiTopUpMessages(2250);
                  }}
                >
                  <div className={styles.optionPrice}>₹4500</div>
                  <div className={styles.optionMessages}>+2250 AI Messages</div>
                  <div className={styles.optionPerMessage}>~₹2 per message</div>
                  {aiTopUpAmount === 4500 && <div className={styles.selectedBadge}>✓ Selected</div>}
                </div>
              </div>

              <div className={styles.checkoutContainer}>
                <RazorpayCheckout
                  cost={aiTopUpAmount}
                  planName={`Top Up - ${aiTopUpMessages} AI Messages`}
                  planCode="TOPUP"
                  userLimit={null}
                  appliedPromo={null}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Ingestion Storage Top-Up Modal */}
      {showIngestionTopUpModal && (
        <div className={styles.modalOverlay} onClick={() => setShowIngestionTopUpModal(false)}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h3>💾 Top Up Ingestion Storage</h3>
              <button
                className={styles.modalClose}
                onClick={() => setShowIngestionTopUpModal(false)}
              >
                ✕
              </button>
            </div>

            <div className={styles.modalBody}>
              <div className={styles.topUpOptions}>
                <div
                  className={`${styles.topUpOption} ${ingestionTopUpAmount === 1500 ? styles.selected : ''}`}
                  onClick={() => {
                    setIngestionTopUpAmount(1500);
                    setIngestionTopUpSize(250000);  // Changed: 750 → 250000
                  }}
                >
                  <div className={styles.optionPrice}>₹1500</div>
                  <div className={styles.optionMessages}>+250000KB Storage</div>  {/* Changed: 750KB → 250000KB */}
                  <div className={styles.optionPerMessage}>~₹0.006 per KB</div>  {/* Changed: ₹2/KB → ~₹0.006/KB */}
                  {ingestionTopUpAmount === 1500 && <div className={styles.selectedBadge}>✓ Selected</div>}
                </div>

                <div
                  className={`${styles.topUpOption} ${ingestionTopUpAmount === 3000 ? styles.selected : ''}`}
                  onClick={() => {
                    setIngestionTopUpAmount(3000);
                    setIngestionTopUpSize(500000);  // Changed: 1500 → 500000
                  }}
                >
                  <div className={styles.optionPrice}>₹3000</div>
                  <div className={styles.optionMessages}>+500000KB Storage</div>  {/* Changed: 1500KB → 500000KB */}
                  <div className={styles.optionPerMessage}>~₹0.006 per KB</div>  {/* Changed: ₹2/KB → ~₹0.006/KB */}
                  {ingestionTopUpAmount === 3000 && <div className={styles.selectedBadge}>✓ Selected</div>}
                </div>

                <div
                  className={`${styles.topUpOption} ${ingestionTopUpAmount === 4500 ? styles.selected : ''}`}
                  onClick={() => {
                    setIngestionTopUpAmount(4500);
                    setIngestionTopUpSize(750000);  // Changed: 2250 → 750000
                  }}
                >
                  <div className={styles.optionPrice}>₹4500</div>
                  <div className={styles.optionMessages}>+750000KB Storage</div>  {/* Changed: 2250KB → 750000KB */}
                  <div className={styles.optionPerMessage}>~₹0.006 per KB</div>  {/* Changed: ₹2/KB → ~₹0.006/KB */}
                  {ingestionTopUpAmount === 4500 && <div className={styles.selectedBadge}>✓ Selected</div>}
                </div>
              </div>

              <div className={styles.checkoutContainer}>
                <RazorpayCheckout
                  cost={ingestionTopUpAmount}
                  planName={`Top Up - ${ingestionTopUpSize}KB Storage`}
                  planCode="INGESTION_TOPUP"
                  userLimit={null}
                  appliedPromo={null}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Site Users Top-Up Modal */}
      {showSiteUsersTopUpModal && (
        <div className={styles.modalOverlay} onClick={() => setShowSiteUsersTopUpModal(false)}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h3>👥 Top Up Site Users</h3>
              <button
                className={styles.modalClose}
                onClick={() => setShowSiteUsersTopUpModal(false)}
              >
                ✕
              </button>
            </div>

            <div className={styles.modalBody}>
              <div className={styles.topUpOptions}>
                <div
                  className={`${styles.topUpOption} ${siteUsersTopUpAmount === 1500 ? styles.selected : ''}`}
                  onClick={() => {
                    setSiteUsersTopUpAmount(1500);
                    setSiteUsersTopUpQuantity(125);  // Changed: 25 → 125
                  }}
                >
                  <div className={styles.optionPrice}>₹1500</div>
                  <div className={styles.optionMessages}>+125 Site Users</div>  {/* Changed: 25 → 125 */}
                  <div className={styles.optionPerMessage}>~₹12 per user</div>  {/* Changed: ₹60 → ~₹12 */}
                  {siteUsersTopUpAmount === 1500 && <div className={styles.selectedBadge}>✓ Selected</div>}
                </div>

                <div
                  className={`${styles.topUpOption} ${siteUsersTopUpAmount === 3000 ? styles.selected : ''}`}
                  onClick={() => {
                    setSiteUsersTopUpAmount(3000);
                    setSiteUsersTopUpQuantity(250);  // Changed: 50 → 250
                  }}
                >
                  <div className={styles.optionPrice}>₹3000</div>
                  <div className={styles.optionMessages}>+250 Site Users</div>  {/* Changed: 50 → 250 */}
                  <div className={styles.optionPerMessage}>~₹12 per user</div>  {/* Changed: ₹60 → ~₹12 */}
                  {siteUsersTopUpAmount === 3000 && <div className={styles.selectedBadge}>✓ Selected</div>}
                </div>

                <div
                  className={`${styles.topUpOption} ${siteUsersTopUpAmount === 4500 ? styles.selected : ''}`}
                  onClick={() => {
                    setSiteUsersTopUpAmount(4500);
                    setSiteUsersTopUpQuantity(375);  // Changed: 75 → 375
                  }}
                >
                  <div className={styles.optionPrice}>₹4500</div>
                  <div className={styles.optionMessages}>+375 Site Users</div>  {/* Changed: 75 → 375 */}
                  <div className={styles.optionPerMessage}>~₹12 per user</div>  {/* Changed: ₹60 → ~₹12 */}
                  {siteUsersTopUpAmount === 4500 && <div className={styles.selectedBadge}>✓ Selected</div>}
                </div>
              </div>

              <div className={styles.checkoutContainer}>
                <RazorpayCheckout
                  cost={siteUsersTopUpAmount}
                  planName={`Top Up - ${siteUsersTopUpQuantity} Site Users`}
                  planCode="SITE_USERS_TOPUP"
                  userLimit={null}
                  appliedPromo={null}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}